import React from 'react'
import PropTypes from 'prop-types'
import ProductionProgress from './components/ProductionProgress'
import * as store from './store'
import { ProductionProgressContextProvider } from './contexts'
import { AsyncModeProvider } from '@wordpress/data'

const ProductionProgressContainer = ({ orderId }) => {
  return (
    <AsyncModeProvider value={true} store={store}>
      <ProductionProgressContextProvider orderId={orderId}>
        <ProductionProgress />
      </ProductionProgressContextProvider>
    </AsyncModeProvider>
  )
}

ProductionProgressContainer.propTypes = {
  orderId: PropTypes.string,
}

export default ProductionProgressContainer
